var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Circle Single",
    clipPath: "url(#clip0_15_8696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-circle-single--circle-geometric-human-person-single-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5001 8.57144C8.21051 8.57144 8.89181 8.28923 9.39414 7.7869C9.89647 7.28457 10.1787 6.60327 10.1787 5.89287C10.1787 5.18246 9.89647 4.50116 9.39414 3.99883C8.89181 3.4965 8.21051 3.21429 7.5001 3.21429C6.7897 3.21429 6.1084 3.4965 5.60607 3.99883C5.10374 4.50116 4.82153 5.18246 4.82153 5.89287C4.82153 6.60327 5.10374 7.28457 5.60607 7.7869C6.1084 8.28923 6.7897 8.57144 7.5001 8.57144Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.92505 12.75C3.40317 11.9652 4.07513 11.3166 4.87634 10.8665C5.67756 10.4164 6.58108 10.18 7.50005 10.18C8.41902 10.18 9.32254 10.4164 10.1238 10.8665C10.925 11.3166 11.5969 11.9652 12.075 12.75",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.50005 14.4643C9.3471 14.4643 11.1185 13.7306 12.4245 12.4245C13.7306 11.1184 14.4643 9.34705 14.4643 7.50001C14.4643 5.65296 13.7306 3.88157 12.4245 2.57551C11.1185 1.26946 9.3471 0.535721 7.50005 0.535721C5.65301 0.535721 3.88162 1.26946 2.57556 2.57551C1.2695 3.88157 0.535767 5.65296 0.535767 7.50001C0.535767 9.34705 1.2695 11.1184 2.57556 12.4245C3.88162 13.7306 5.65301 14.4643 7.50005 14.4643Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_8696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/UserCircle.cc9ef41ebbfd1316e390d13ac170b31c.svg";
export { ForwardRef as ReactComponent };